import styled from 'styled-components';

export const CardContent = styled.div`
  display: flex;
  justify-content: space-between;
  // flex-wrap: wrap;
  padding: 10px;
  gap: 12px;
  border-radius: 8px;
  background: ${(props) =>
    props.$active ? 'rgba(35, 16, 39, 0.60)' : 'rgba(35, 16, 39, 0.30)'};
  max-width: 338px;
  position: relative;
`;

export const InfoBlock = styled.div`
  display: flex;
  gap: 12px;
`;

export const TopInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const BottomInfo = styled.div`
  opacity: 0.7;
  padding: 3px 0;
`;

export const SwitchBlock = styled.div`
    bottom: 10px;
    position: absolute;
    right: 10px;
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
